export default () => {
    const route = window.location.pathname
    const items = localStorage.menuitem
        ? JSON.parse(localStorage.menuitem)
        : []

    const i = items.findIndex(item => item.IMenuLinkTo === route)
    if (i >= 0) return items[i]

    const activeTab = localStorage.getItem('dm_active_tab')
    if (activeTab) {
        const j = items.findIndex(item => (item.id || item.ModuleKey) === activeTab)
        if (j >= 0) return items[j]
    }

    return null
}